import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Get scene design data */
export async function getSceneDesign(projectId, sceneNumber) {
  const { data } = await axios.get(`${API}/scene-design/${projectId}/${sceneNumber}`);
  return data;
}

/** Save scene design — accepts full scene design data object */
export async function saveSceneDesign(sceneData) {
  const { data } = await axios.post(`${API}/scene-design/save`, sceneData);
  return data;
}

/** Lock scene design for production */
export async function lockSceneDesign(lockData) {
  const { data } = await axios.post(`${API}/scene-design/lock`, lockData);
  return data;
}

/** Generate costume design (AI) */
export async function generateCostume(costumeData) {
  const { data } = await axios.post(`${API}/scene-design/generate-costume`, costumeData);
  return data;
}

/** Generate blocking shot (AI) */
export async function generateBlockingShot(blockingData) {
  const { data } = await axios.post(`${API}/scene-design/generate-blocking-shot`, blockingData);
  return data;
}

/** Get continuity report for a scene */
export async function getContinuityReport(projectId, sceneNumber) {
  const { data } = await axios.get(`${API}/scene-design/continuity-report/${projectId}/${sceneNumber}`);
  return data;
}

/** Generate a new continuity report */
export async function generateContinuityReport(reportData) {
  const { data } = await axios.post(`${API}/scene-design/continuity-report`, reportData);
  return data;
}
